/**
 * @description 
 */
export default function () {
    return {
        menues: null,
        titleTopBar: '',
        items: [],
    }
}